import * as React from "react";
import type { SVGProps } from "react";
const SvgSave = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 19H2zM5 3V2zm11 0 .707-.707A1 1 0 0 0 16 2zm5 5h1a1 1 0 0 0-.293-.707zm-5 13a1 1 0 1 0 2 0zm1-8h1a1 1 0 0 0-1-1zM7 13v-1a1 1 0 0 0-1 1zm-1 8a1 1 0 1 0 2 0zM8 3a1 1 0 0 0-2 0zM7 8H6a1 1 0 0 0 1 1zm8 1a1 1 0 1 0 0-2zm4 11H5v2h14zM5 20a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 5 22zm-.707-.293A1 1 0 0 1 4 19H2a3 3 0 0 0 .879 2.121zM4 19V5H2v14zM4 5a1 1 0 0 1 .293-.707L2.879 2.879A3 3 0 0 0 2 5zm.293-.707A1 1 0 0 1 5 4V2a3 3 0 0 0-2.121.879zM5 4h11V2H5zm10.293-.293 5 5 1.414-1.414-5-5zM20 8v11h2V8zm0 11a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 22 19zm-.293.707A1 1 0 0 1 19 20v2a3 3 0 0 0 2.121-.879zM18 21v-8h-2v8zm-1-9H7v2h10zM6 13v8h2v-8zM6 3v5h2V3zm1 6h8V7H7z"
    />
  </svg>
);
export default SvgSave;
